
import React from 'react';
import { useAdmin } from '@/contexts/AdminContext';
import AdminLogin from '@/components/admin/AdminLogin';
import AdminDashboard from '@/components/admin/AdminDashboard';

const AdminPage = () => {
  const { isLoggedIn } = useAdmin();

  return isLoggedIn ? <AdminDashboard /> : <AdminLogin />;
};

export default AdminPage;
